import { firebaseAuth } from '@fable/api'
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth'
import React, { useEffect } from 'react'

function sendResponse(result: any, frame: string) {
  globalThis.parent.self.postMessage(JSON.stringify(result), frame)
}

const ExtAuthPage: React.FC = () => {
  useEffect(() => {
    console.log('ExtAuthPage loaded')
    const parentFrame = document.location.ancestorOrigins[0]
    const handleMessage = ({ data }: MessageEvent) => {
      if (data.initAuth) {
        signInWithPopup(firebaseAuth, new GoogleAuthProvider())
          .then((x) => sendResponse(x, parentFrame))
          .catch((x) => sendResponse(x, parentFrame))
      }
    }

    globalThis.addEventListener('message', handleMessage)

    return () => {
      globalThis.removeEventListener('message', handleMessage)
    }
  }, [])

  return null
}

export default ExtAuthPage
